import React from 'react'
import {connect} from 'react-redux'

import '../../asset/less/Order.css'
import {message, Tag, Typography} from 'antd'
import {withRouter} from 'react-router'
import moment from 'moment'
import {ArrowDownOutlined, ArrowUpOutlined} from '@ant-design/icons'
import GalleryTablePanel from '../../component/GalleryTablePanel'
import {getEditUrl} from '../../component/Utils'

import {deleteArtistSaleReports, getArtistSaleReports, postArtistSaleReports} from '../../api/artistSaleReports'
import {getFullNameByArtist} from '../../app/util'
import {colorArray, getPaymentStr, getPaymentText, orderColumns} from '../../component/income/OrderTable'
import {URL_EDIT_ORDERS, URL_NEW_ORDERS, URL_ORDER_DETAILS} from '../../const';
import {TYPE_ORDER} from '../../component/base/filters/FilterUtils'
import {is_admin_user} from "../../app/role";

const {Title} = Typography

const orderSortOptions = [
    {
        text: 'Order ID (Ascending)',
        value: 'id',
        icon: <ArrowUpOutlined/>
    },
    {
        text: 'Order ID (Descending)',
        value: '-id',
        icon: <ArrowDownOutlined/>
    },
    {
        text: 'Date (Oldest)',
        value: 'date',
        icon: <ArrowUpOutlined/>
    },
    {
        text: 'Date (Newest)',
        value: '-date',
        icon: <ArrowDownOutlined/>
    },
    {
        text: 'Price (Highest)',
        value: 'sku_price',
        icon: <ArrowUpOutlined/>
    },
    {
        text: 'Price (Lowest)',
        value: '-sku_price',
        icon: <ArrowDownOutlined/>
    },
]

@connect((state) => ({

        artistId: state.user.info.artistId,
        role: state.user.info.role,
        artists: state.artist.artists,
    }),
    {})
class Order extends React.Component {
    constructor(props) {
        super(props)
        this.query = new URLSearchParams(this.props.location.search)
        this.ref = React.createRef()
        this.addFormRef = React.createRef()
        this.state = {
            dataSource: [],
            current: this.query.get('page'),
            pageSize: 100,
            editableKeys: [],
            drawerVisible: false,
            addARowDisable: false,
            editing: false,
            filterModalVisible: false
        }
        this.filterOptions = [{
            type: TYPE_ORDER
        }]
        this.artists = this.props.artists.map((artist) => ({
            id: artist.artist,
            name: getFullNameByArtist(artist)
        }))
        this.extral_column = [
            {
                title: 'Payment',
                dataIndex: 'payment_status',
                width: 156,
                editable: false,
                key: 'payment_status',
                render: (text, value) => (
                    <Tag color={colorArray.payment[getPaymentStr(text)]}>{getPaymentText(text)}</Tag>
                )
            },
        ]
    }

    onClose = () => {
        this.setState({
            drawerVisible: false
        })
    }

    onFinish = (values) => {
        const params = {
            date: moment().format('YYYY-MM-DD'),
            artist: this.props.artistId,
            sku_type: '',
            ...values
        }
        postArtistSaleReports(params)
            .then((response) => {
                message.success('Save successfully').then((r) => {
                })
                this.ref?.current.reload()
                this.onClose()
            })
            .catch((error) => {
                message.error(error.message).then((r) => {
                })
            })
        this.setState({
            editing: false
        })
    }

    onAddClick = () => {
        this.props.history.push({pathname: URL_NEW_ORDERS});
    }

    requestData = (pageId, pageSize, sort, filters, search, cancelToken) => {
        // prepare your data from Apis or local tests
        return getArtistSaleReports({
            paymentFilter: filters.paymentFilter,
            fulfillmentFilter: filters.fulfillmentFilter,
            artTypeFilter: filters.artTypeFilter,
            start: filters.start,
            end: filters.end
        }, search, pageId, pageSize, sort, this.props.artistId, cancelToken)
    }

    deleteData = (id) => {
        // call api to delete by id
        return deleteArtistSaleReports(id)
    }

    getEditUrl = (element) => {
        // change to your own model edit url
        return getEditUrl(URL_EDIT_ORDERS, element.id)
    }

    getDetailsUrl = (element) => {
        return getEditUrl(URL_ORDER_DETAILS, element.id)
    }

    render() {
        return (
            <div>
                <GalleryTablePanel requestData={this.requestData}
                                   name={'order'}
                                   columns={is_admin_user(this.props) ? orderColumns.concat(this.extral_column) : orderColumns}
                                   tableWidth={1200}
                                   viewOptions={['table']}
                                   filterOptions={this.filterOptions}
                                   sortOptions={orderSortOptions} defaultSortOption={orderSortOptions[1].value}
                                   disableAdd={!is_admin_user(this.props)}
                                   disableImport={!is_admin_user(this.props)}
                                   getEditUrl={is_admin_user(this.props) ? this.getEditUrl : null}
                                   getDetailsUrl={this.getDetailsUrl}
                                   deleteData={is_admin_user(this.props) ? this.deleteData : null}
                                   addNewUrl={URL_NEW_ORDERS}
                                   exportFileName={'order'}
                />
            </div>
        )
    }
}

export default withRouter(Order)